// trailhead nav events, for continuity of measurements
import track from '../lib/tracking/track';

// Some XSF nav clicks arrive with navItem missing or set to the literal string
// "undefined". Label them by destination (query string and hash dropped) so
// they're attributable. clickText is deliberately not used: the profile menu
// can contain the user's name.
const navItemLabel = ({ navItem, clickURL }) => {
  if (navItem && navItem !== 'undefined') return navItem;
  if (!clickURL) return 'unlabeled';

  return `unlabeled:${clickURL.split(/[?#]/)[0]}`;
};

window.digitalNavTracking = (data) => {
  let { detail, property } = data;

  // only handle custEv_navigationClick
  if(detail.event !== "custEv_navigationClick") {
    return
  }

  // custEv_navigationClick not supported by schema using nav_clicked
  let eventName = 'nav_clicked';

  let payload = {
    // set in _javascript_packs
    "lang": window.locale,
    // no stable property across locales... needs improvement
    "label": navItemLabel(detail),
    // property is trailhead or community
    // navType is global or context:static
    "pageLocation": `digital_nav_${property}_${detail.navType}`
  };

  track(eventName, payload);
}

document.addEventListener('www_track', (e) => {
  try {
    if(window.dataLayer) {
      window.dataLayer.push(e.detail);
    }
  } catch {
    console.log('Could not push event detail to GTM');
  }

  let data = {
    detail: e.detail,
    property: window?.Trailhead?.property,
    location: e.detail.navType
  }

  window.digitalNavTracking(data);
});

document.addEventListener('xsf_track', (e) => {
  let data = {
    detail: e.detail,
    property: window?.Trailhead?.property,
    location: e.detail.navType
  }

  window.digitalNavTracking(data);
});
